<template>
  <div class="invoice">
    <re-dialog title="选择发票" :visible.sync="visible" width="1400px">
      <div slot="title" class="fr ac jsb head">
        <p class="fz14 black bold">选择发票</p>
        <i class="el-icon-close fz14 cursor" @click="visible = false"></i>
      </div>
      <el-table
          border
          :data="invoice_list"
          ref="singleTable"
          max-height="400"
          v-infinite-scroll="getInvoices"
          infinite-scroll-disabled="invoice_finished"
          style="width: 100%"
          header-align="center"
          highlight-current-row
          @row-click="showRow"
      >
        <el-table-column label="操作" width="70" align="center">
          <template slot-scope="scope">
            <el-radio class="radio" v-model="radio" :label="scope.row.invoice_id">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column label="发票类型" align="center" width="100">
          <template slot-scope="scope">{{ scope.row.invoice_type == '1' ? "增值税普票" : "增值票专票" }}</template>
        </el-table-column>
        <el-table-column prop="invoice_name" width="200" label="发票公司名" align="center"></el-table-column>
        <el-table-column prop="invoice_taxno" width="200" label="税号" align="center"></el-table-column>
        <el-table-column prop="invoice_mobile" label="注册电话" align="center"></el-table-column>
        <el-table-column prop="invoice_bank_name" label="开户行" align="center"></el-table-column>
        <el-table-column prop="invoice_back_no" width="200" label="银行卡号" align="center"></el-table-column>
        <el-table-column prop="invoice_address" width="200" label="注册地址" align="center"></el-table-column>
        <el-table-column prop="invoice_name" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click.stop="editInvoice(scope.row)">修改发票</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="fr ac jc mt20">
        <el-button type="primary" style="width:100px" @click="submit">确认</el-button>
      </div>
    </re-dialog>
    <!-- 添加发票 -->
    <add-invoice
        :company_id="company_id"
        :invoiceVisible.sync="add_invoice_show"
        @cloneVisible="cloneVisible"
        :info="current_info"
        type="edit"
    />
  </div>
</template>

<script>
import AddInvoice from "@/components/AddInvoice";

export default {
  props: {
    invoiceVisible: Boolean,
    company_id: String,
    invoice_id: Number
  },
  components: {AddInvoice},
  data() {
    return {
      invoice_json: {},
      radio: "0",
      visible: false,
      invoice_list: [], //发票
      invoice_page: 0, //发票页数
      invoice_total: 0, //发票total
      invoice_finished: false, //发票是否加载完成
      add_invoice_show: false,
      current_info: {},

    };
  },
  watch: {
    invoiceVisible(n) {
      this.visible = n;
      if (!n) {
        this.invoice_page = 0;
        this.radio = this.invoice_id;
        this.getInvoices();
      }

    },
    visible(n) {
      this.$emit("update:invoiceVisible", n);
    },
    invoice_id(n) {
      this.radio = n;
    }
  },
  methods: {
    cloneVisible() {
      this.invoice_finished = false;
      this.invoice_page = 0;
      this.getInvoices();
    },
    editInvoice(info) {
      this.current_info = info;
      this.add_invoice_show = true;
    },
    // 获取发票
    getInvoices() {
      if (this.is_Empty(this.company_id) && this.hasMemberType(4)) {
        return;
      }
      if (this.invoice_finished) return;
      this.invoice_page++;
      let obj = {
        page: this.invoice_page
      };
      if (this.company_id) {
        obj.company_id = this.company_id;
      }
      this.post("invoiceInterfaces/v1.0/getInvoices", obj).then(res => {
        if (res.status == "ok") {
          this.invoice_list =
              this.invoice_page == 1
                  ? res.data
                  : this.invoice_list.concat(res.data);
          this.invoice_finished = this.invoice_list >= res.total;
          this.invoice_total = res.total;
        }
      });
    },
    showRow(row) {
      this.invoice_json = row;
      this.radio = row.invoice_id;
    },
    submit() {
      this.visible = false;
      this.$emit("selectInvoice", this.invoice_json);
    }
  }
};
</script>

<style scoped lang="scss">
.invoice {
  .address_title {
    width: 10%;
  }

  .el-dialog {
    .el-dialog__header {
      background-color: #eaeaea;
      height: 40px;
      padding: 0 20px;

      .head {
        height: 100%;
      }
    }
  }

  .el-table {
    // max-height: 400px;
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectInvoice.vue